import { render, staticRenderFns } from "./AddReleaseNote.vue?vue&type=template&id=f4d5307a"
import script from "./AddReleaseNote.vue?vue&type=script&lang=js"
export * from "./AddReleaseNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports